<template>
  <v-menu
    v-model="menu"
    transition="scale-transition"
    max-width="290px"
    min-width="auto"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="fecha"
        :label="label"
        :clearable="clearable"
        :hide-details="hideDetails"
        readonly
        outlined
        filled
        dense
      >
        <template v-slot:append-outer>
          <v-icon
            v-bind="attrs"
            v-on="on"
            :color="disabled ? '' : 'info'"
            :title="disabled ? '' : 'Seleccionar fecha'"
            :disabled="disabled"
            @click="date = parseDate(fecha)"
          >
            fas fa-calendar-day
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { formatDate, parseDate } from '../../utils'

export default {
  data () {
    return {
      parseDate: parseDate,
      menu: false,
      date: null
    }
  },
  props: {
    p_fecha: String, // en formato DD/MM/AAAA
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    date (val) {
      this.fecha = formatDate(val)
    }
  },
  computed: {
    fecha: {
      get () {
        return this.p_fecha
      },
      set (value) {
        this.$emit('update:p_fecha', value)
      }
    }
  }
}
</script>